import DarkMode from "./Components/DarkMode"
import DateTime from "./Components/DateTime"
import Quit from "./Components/Quit"
import LogoWhite10 from "../../Media/PNG/LogoWhite10.svg"
import Hamburger from "../Aside/Components/Hamburger"
import { useState } from "react"
import ContainerHamburger from "../Aside/ContainerHamburger"
import { Link } from "react-router-dom"

export default function Container() {
  const [isCollapsed, setIsCollapsed] = useState(true)
  const onToggle = () => {
    setIsCollapsed(pre => !pre)
  }

  const handleCloseHamburger = () => {
    setIsCollapsed(true)
  }

  return (
    <header className="w-dvw flex items-center justify-between px-5 py-3 bg-zi-gradient-header">
      <Hamburger isCollapsed={isCollapsed} onToggle={onToggle}/>
      <ContainerHamburger isCollapsed={isCollapsed} onClose={handleCloseHamburger}/>
      <Link to={"/dashboard"} className="flex items-center gap-4">
        <img src={LogoWhite10} alt="لوگو" className="w-9 drop-shadow-md"/>
        <p className="text-lg text-white font-medium drop-shadow-md hidden md:block">کوژیتو فاند</p>
      </Link>
      <div className="flex items-center gap-6 sm:gap-12">
        <div className="hidden md:block"><DateTime/></div>
        <DarkMode/>
        <Quit/>
      </div>
    </header>
  )
}